import { createUseStyles } from 'react-jss';
import { ITheme } from '../../components/theme';

type RuleNames =
  | 'mainGrid';

const PREFIX = 'CardsPage';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      mainGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 272px)',
        width: '1160px',
        justifyContent: 'space-between',
        margin: '0 auto',
      },
    }
  ),
  { name: PREFIX },
);
